import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { DELETE_TRUSTS_USER_MUTATION } from '../graphql/mutations/deleteTrustsUser';
import { GET_TRUSTS_USERS } from '../graphql/queries/getTrustsUsers';

export const useDeleteTrustsUser = () => {
  const [deleteTrustsUserMutation, { data, loading, error }] = useMutation(DELETE_TRUSTS_USER_MUTATION, {
    refetchQueries: [{ query: GET_TRUSTS_USERS }]
  });

  const deleteTrustsUser = async (email: string) => {
    const variables = { trustsUserDeleteDto: { email } };
    try {
      await deleteTrustsUserMutation({ variables });
      toast.success('User deleted successfully!');
      return { error: false };
    } catch (err) {
      toast.error(`There was an error deleting the user: ${(err as Error).message}`);
      return { error: true };
    }
  };

  return { deleteTrustsUser, data, loading, error };
};
